import { withAsyncLoading } from '../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadablePlanningPage = withAsyncLoading(async () =>
    import('./PlanningPage').then((res) => res.PlanningPage)
);

export { LoadablePlanningPage };
